module.exports = __webpack_public_path__ + "static/media/Calculator.f3682663.svg";